import { useEffect, useRef, useState } from "react";

import { ClassroomStudent } from "@/types/models/Classroom.interface";
import ActivityFilter from "./ActivityFilter";
import ClassroomFilter from "./ClassroomFilter";
import DateRangeFilter from "./DateRangeFilter";
import {
  pageFiltersContainerCss,
  studentFilterContainerCss,
  activityFilterContainerCss,
  dateFilterContainerCss,
} from "./InsightsPageFilters.style";
import StudentFilter from "./StudentFilter";

export interface InsightsPageFiltersProps {
  isClassroomReportPage: boolean;
  studentList?: ClassroomStudent[] | undefined;
  hideActivityFilter?: boolean;
}

const InsightsPageFilters = ({
  isClassroomReportPage,
  studentList,
  hideActivityFilter = false,
}: InsightsPageFiltersProps) => {
  const [isSticky, setIsSticky] = useState(false);
  const stickyRef = useRef(null);

  const checkStickiness = () => {
    const node = stickyRef.current;
    if (node) {
      const rect = (node as HTMLElement).getBoundingClientRect();
      setIsSticky(rect.top <= 0);
    }
  };

  useEffect(() => {
    const mainElement = document.getElementById("__next");
    mainElement?.addEventListener("scroll", checkStickiness);
    return () => mainElement?.removeEventListener("scroll", checkStickiness);
  }, []);

  return (
    <div
      ref={stickyRef}
      css={pageFiltersContainerCss(isSticky)}
      data-testid="insights-page-filters"
    >
      <div css={studentFilterContainerCss}>
        {isClassroomReportPage ? (
          <ClassroomFilter />
        ) : (
          <StudentFilter studentList={studentList} />
        )}
      </div>
      {!hideActivityFilter && (
        <div css={activityFilterContainerCss}>
          <ActivityFilter />
        </div>
      )}
      <div css={dateFilterContainerCss}>
        <DateRangeFilter isClassroomReportPage={isClassroomReportPage} />
      </div>
    </div>
  );
};

export default InsightsPageFilters;
